module.exports = __webpack_public_path__ + "static/media/audi_zertifikat_2015.6bf4c663.jpg";